import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "sonner";

export default function Layout({ children }) {
    return (
        <div className="App min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}
